<template>
  <div>
    <v-footer class="footer">
      <div class="w-100">
        <v-row class="my-0">
          <v-col class="centered-on-mobile text-center" cols="12">
            XIGA MARKETING S.R.L. <br/>
            CIF: RO46249361, Nr. Registrul Comertului: J12/3323/2022, Sediu social: Str. Avram Iancu, Nr. 500, Et. 2, Florești, Cluj <br/>
            <br/>
            XIGA este inregistrata la Autoritatea pentru Supraveghere Financiara (ASF) in Registrul Intermediarilor Secundari ca asistent in brokeraj al TRANSILVANIA BROKER DE ASIGURARE S.A., cu cod unic 536334.
          </v-col>
        </v-row>
      </div>
    </v-footer>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, computed, ref} from 'vue';
import {useTranslationStore, translation} from '~/plugins/store/translations';
import {useRouter, useRoute} from 'vue-router';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  setup() {
    const translationStore = useTranslationStore();
    const translationList = ref<TranslationList>({}); // Initialize translations as a reactive reference

    const route = useRoute();

    //Loading translations when component is mounted
    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
    });



    return {
      translationList,
      translation,
    };
  },
});
</script>


<style scoped>

</style>
